import { Moment } from "moment";

const localDayName = (day: Moment) => {
    const dayName = day.format("dddd");

    return `${dayName.charAt(0).toUpperCase()}${dayName.slice(1)}`;
};

const localMonthName = (date: Moment) => {
    const weekName = date.format("MMMM").trim();

    return `${weekName.charAt(0).toUpperCase()}${weekName.slice(1)}`;
};

export { localDayName, localMonthName };
